import React, { useState, useEffect }  from 'react';
import styled from 'styled-components';

// Components
import Preset from './Preset';
import Button from '../../Button/Button';

const UserPresets = ({
  presets,
  setDefaultPreset,
  onResetPreset,
  agGridApi,
  // disableSave,
  updatePreset,
  onLoad,
  onOpenModal
}) => {
  const [disableSave, setDisableSave] = useState(false);

  useEffect(() => {
    let activatePreset = presets.some(preset => preset.is_active);
    setDisableSave(activatePreset);

  }, [presets])
  if(presets.length === 0) {
    return (
      <EmptyContainer>
        <EmptyContent>
          You do not have any saved presets
        </EmptyContent>
        <ActionContainer>
          <Button 
            size="sm"
            disabled={disableSave}
            onClick={() => onOpenModal("add-preset")}>
            Save Current View as Preset
          </Button>
          <Button 
            variant="link"
            style={{ marginTop: 10 }}
            onClick={onResetPreset}>
            Reset View
          </Button>
        </ActionContainer>
      </EmptyContainer>
    )
  }
  
  return (
    <Container>
      <PresetContainer>
        {presets.map((preset, i) => {
          return (
            <Preset 
              key={i} 
              index={i}
              agGridApi={agGridApi}
              setDefaultPreset={setDefaultPreset}
              onLoad={onLoad}
              updatePreset={updatePreset}
              onOpenModal={onOpenModal}
              {...preset}/>)
        })}
      </PresetContainer>


      <ActionContainer>
        <Button 
          size="sm"
          disabled={disableSave}
          onClick={() => onOpenModal("add-preset")}>
          Save Current View as Preset
        </Button>
        <Button 
          variant="link"
          style={{ marginTop: 10 }}
          onClick={onResetPreset}>
          Reset View
        </Button>
      </ActionContainer>
    </Container>
  );
};

export default UserPresets;

const Container = styled.div`
  height: 100%;
`

const EmptyContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
`

const EmptyContent = styled.div`
  height: calc(100% - 90px);
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 16px;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0;
`

const ActionContainer = styled.div`
  height: 90px;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-top: 1px solid lightgrey;
  z-index: 1000;
`

const PresetContainer = styled.div`
  height: calc(100% - 90px);
  overflow-y: scroll;
`